import React from 'react';
import { Building2, Hotel, HeartHandshake, Users, UserCog, Briefcase } from 'lucide-react';
import { Reveal, SectionEyebrow, SectionTitle, Container } from './Primitives';
import { useLanguage } from '@/context/LanguageContext';
import { SITE } from '@/constants/testIds';

const icons = [Building2, Hotel, HeartHandshake, Users, UserCog, Briefcase];

const Audience = () => {
  const { t } = useLanguage();
  return (
    <section
      id="audience"
      data-testid={SITE.sectionAudience}
      className="relative py-20 lg:py-32 bg-[#F7F8F5]"
    >
      <Container>
        <div className="max-w-2xl">
          <Reveal>
            <SectionEyebrow>{t.audience.eyebrow}</SectionEyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <SectionTitle className="mt-4">{t.audience.title}</SectionTitle>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.audience.items.map((item, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={item.title} delay={(i % 3) * 0.06}>
                <article
                  data-testid={SITE.audienceCard}
                  className="h-full bg-white rounded-2xl p-7 border border-[rgba(0,166,81,0.1)] hover:border-[rgba(0,166,81,0.35)] transition-all duration-300 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.05)] hover:shadow-[0_18px_40px_-10px_rgba(0,166,81,0.18)] hover:-translate-y-1 group flex flex-col"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#F7F8F5] flex items-center justify-center group-hover:bg-[#00A651]/10 transition-colors">
                    <Icon size={22} className="text-[#00A651]" />
                  </div>
                  <h3 className="mt-5 font-['Outfit'] text-lg font-semibold text-[#0B0F0C]">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed flex-1">{item.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default Audience;
